import { risapi } from './risapi';
import { getAxiosConfig } from './risapi';

export const loginUser = async (credentials, callback) => {
    try {
        // This is a public endpoint, so no auth headers are needed.
        const response = await risapi.post('/api/login', credentials);

        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        // Pass the full error object to the component for detailed handling
        callback(error);
    }
};

export const getAuthUser = async (callback) => {
    try {
        // This request requires an authorization token, provided by getAxiosConfig()
        const response = await risapi.get('/api/user', getAxiosConfig());

        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        callback(error);
    }
};

